import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=73b9b6d1&scoped=true&"
import script from "./LandingFooter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandingFooter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LandingFooter.vue?vue&type=style&index=0&id=73b9b6d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9b6d1",
  null
  
)

export default component.exports